import React from "react";
import { useTranslation } from "react-i18next";
import { Mic, Play, RotateCcw } from "lucide-react";

import { Phase } from "../../types";
import type { FlowMode } from "../../types";

import type { BriefData, ScoreData } from "../../services/api";

interface IdleControlsProps {
  phase: Phase;
  flowMode: FlowMode;
  scoreData: ScoreData | null;
  briefData: BriefData | null;
  handleStartLiveConsultation: () => void;
  handleStartBriefing: () => void;
  handleReplayBriefing: () => void;
  handleEndConsultation: () => void;
}

const IdleControls: React.FC<IdleControlsProps> = ({
  phase,
  flowMode,
  scoreData,
  briefData,
  handleStartLiveConsultation,
  handleStartBriefing,
  handleReplayBriefing,
  handleEndConsultation,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {phase === Phase.IDLE &&
        (flowMode === "liveOnly" ? (
          <button
            onClick={handleStartLiveConsultation}
            disabled={!scoreData}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <Mic size={20} />
            {t("startLiveConsultation")}
          </button>
        ) : (
          <button
            onClick={handleStartBriefing}
            disabled={briefData?.audio_url === undefined}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <Play size={20} fill="currentColor" />
            {t("startBriefing")}
          </button>
        ))}

      {phase === Phase.BRIEFING_COMPLETED && (
        <div className="btn-group">
          <p
            style={{
              margin: "0 0 16px 0",
              alignSelf: "center",
              fontSize: "0.9rem",
              color: "#64748b",
              fontWeight: 600,
            }}
          >
            {t("briefingCompleted")}
          </p>
          <div className="btn-actions">
            <button
              className="btn-toggle"
              onClick={handleReplayBriefing}
              disabled={briefData?.audio_url === undefined}
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <RotateCcw size={18} />
              {t("replayBriefing")}
            </button>

            {flowMode !== "briefOnly" && (
              <button
                className="btn-toggle"
                onClick={handleStartLiveConsultation}
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Mic size={18} />
                {t("startLiveConsultation")}
              </button>
            )}

            {flowMode === "briefOnly" && (
              <button className="btn-end" onClick={handleEndConsultation}>
                {t("endConsultation")}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default IdleControls;
